import React, { useEffect } from 'react';

const Toast = ({ type = 'info', message = '', onClose, duration = 5000 }) => {
    useEffect(() => {
        if (message && onClose && duration) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [message, onClose, duration]);

    if (!message) return null;

    const styles = {
        success: {
            bg: '#064e3b',
            border: '#059669',
            text: '#34d399',
            icon: '✓',
        },
        error: {
            bg: '#7f1d1d',
            border: '#dc2626',
            text: '#fca5a5',
            icon: '✕',
        },
        warning: {
            bg: '#78350f',
            border: '#d97706',
            text: '#fcd34d',
            icon: '⚠️',
        },
        info: {
            bg: '#1e3a8a',
            border: '#2563eb',
            text: '#93c5fd',
            icon: 'ℹ',
        },
    };

    const currentStyle = styles[type] || styles.info;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '24px',
                right: '24px',
                zIndex: 9999,
                backgroundColor: currentStyle.bg,
                borderLeft: `4px solid ${currentStyle.border}`,
                color: currentStyle.text,
                padding: '14px 20px',
                borderRadius: '8px',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                maxWidth: '400px',
                fontSize: '14px',
                animation: 'slideIn 0.3s ease-out',
            }}
        >
            <span style={{ fontWeight: 'bold', fontSize: '16px' }}>{currentStyle.icon}</span>
            <div style={{ flexGrow: 1 }}>{message}</div>
            {onClose && (
                <button
                    onClick={onClose}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: currentStyle.text,
                        cursor: 'pointer',
                        opacity: 0.8,
                        fontSize: '16px',
                        padding: '0 4px',
                    }}
                >
                    ✕
                </button>
            )}
        </div>
    );
};

export default Toast;
